import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Products from "../Products/Products";
import { client } from "../../lib/client";
import "./Category.scss";

const Category = () => {
  const { id } = useParams(); // get the id parameter from the URL
  const [category, setCategory] = useState([]);
  console.log(category.brand);
  useEffect(() => {
    const query = '*[_type == "product"]';

    client.fetch(query).then((data) => {
      const filteredData = data.filter((item) => item.brand === id);
      setCategory(filteredData);
    });
  }, [id]);
  

  return (
    <div className="main-container">
    <div className="category-main-content">
      <div className="layout">
        <div className="category-title">{category[0]?.brand}</div>
        <Products innerPage={true} products={category} />
      </div>
    </div>
    </div>
  );
};

export default Category;